import React, { useEffect, useState } from 'react';
import { orderAPI } from './SellerApi';

export const SellerOrders = () => {
  const [orders, setOrders] = useState([]);
  const [filter, setFilter] = useState('all');
  const [loading, setLoading] = useState(true);
  const [updating, setUpdating] = useState({});

  // 1. Define the status flow configuration here
  const STATUS_FLOW = { 
    pending: ['accept'],
    processing: ['shipped', 'cancelled'], 
    shipped: ['delivered'], 
    delivered: [], 
    cancelled: [] 
  };

  const fetchOrders = () => {
    setLoading(true);
    orderAPI.list({ status: filter })
      .then(r => setOrders(r.data || []))
      .catch((err) => {
        console.error("Failed to load orders:", err);
        setOrders([]);
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    fetchOrders();
  }, [filter]);

  const handleAction = async (id, currentStatus, nextAction) => {
    setUpdating(u => ({ ...u, [id]: true }));
    try {
      if (currentStatus === 'pending') {
        await orderAPI.accept(id); 
      } else {
        await orderAPI.updateStatus(id, nextAction); 
      }
      fetchOrders(); 
    } catch (err) {
      alert(err.message || "Action failed");
    } finally {
      setUpdating(u => ({ ...u, [id]: false }));
    }
  };

  return (
    <div>
      <div style={{ display: 'flex', gap: '0.5rem', marginBottom: '1.5rem', flexWrap: 'wrap' }}>
        {['all', 'pending', 'processing', 'shipped', 'delivered', 'cancelled'].map(f => (
          <button 
            key={f} 
            onClick={() => setFilter(f)} 
            style={{ 
              padding: '0.45rem 1rem', 
              borderRadius: '50px', 
              fontSize: 12.5, 
              fontWeight: 600, 
              background: filter === f ? 'var(--em-400)' : 'var(--s2)', 
              color: filter === f ? 'var(--s0)' : 'var(--t2)', 
              border: '1px solid var(--border-hi)', 
              cursor: 'pointer', 
              textTransform: 'capitalize' 
            }}
          >
            {f}
          </button>
        ))}
      </div>

      <div className="sp-card">
        {loading ? (
          <div className="sp-skeleton" style={{ height: 200 }} />
        ) : (
          <div className="sp-table-wrap">
            <table className="sp-table">
              <thead>
                <tr>
                  <th>Order ID</th>
                  <th>Product</th>
                  <th>Customer</th>
                  <th>Qty</th>
                  <th>Total</th>
                  <th>Date</th>
                  <th>Status</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {/* 'o' is defined here as the current order item */}
                {orders.map(o => {

console.log("Order Status:", o.status);
return (
                  <tr key={o.db_id}>
                    <td className="td-hi">#{o.order_id}</td>
                    <td>{o.product_name}</td>
                    <td>{o.customer_name}</td>
                    <td>{o.qty || 1}</td>
                    <td className="td-em">₹{o.total}</td>
                    <td style={{ fontSize: 12, color: 'var(--t3)' }}>
                      {new Date(o.created_at).toLocaleDateString('en-IN')}
                    </td>
                    <td>
                      <span className={`sp-badge ${o.status}`}>{o.status}</span>
                    </td>
                    <td>
  <div style={{ display: 'flex', gap: '0.4rem', flexWrap: 'wrap' }}>
    {/* Use optional chaining and toLowerCase() to match the data */}
    {STATUS_FLOW[o.status?.toLowerCase()]?.map(next => (
      <button 
        key={next} 
        className="sp-btn-secondary" 
        style={{ padding: '4px 10px', fontSize: 11, textTransform: 'capitalize' }} 
        disabled={updating[o.db_id]} 
        onClick={() => handleAction(o.db_id, o.status, next)}
      >
        {next}
      </button>
    ))}
  </div>
</td>
                  </tr>
              );
            })}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default SellerOrders;